import URL from 'shared/utils/url';

// ADI adds one of this params to endpoint URI
// TODO: find a better way to determine ADI env
const expectedOrigins = [
  'ADI-section',
  'ADI-topbar-single',
  'settings-panel',
];

export default () =>
  _.includes(expectedOrigins, (new URL(window.location.href)).getParam('origin'));



// WEBPACK FOOTER //
// ./src/shared/utils/is-adi.js